import { z } from "zod";

// Zod schemas for Socket.io event payloads — runtime validation
// Mirrors interfaces in types.socket.ts but enforces at runtime
// Uses .passthrough() so unknown future fields are preserved, not rejected

export const assessmentRoomsReadyEventSchema = z
  .object({
    event_type: z.string(),
    agent_session_id: z.string(),
    timestamp: z.string(),
  })
  .passthrough();

export type AssessmentRoomsReadyEventParsed = z.infer<
  typeof assessmentRoomsReadyEventSchema
>;

export const followUpQuestionsGeneratedEventSchema = z
  .object({
    event_type: z.string(),
    vendor_email: z.string(),
    timestamp: z.string(),
    data: z.record(z.unknown()),
    chat_id: z.string(),
    questions: z.array(
      z.object({
        id: z.string(),
        question: z.string(),
      }),
    ),
    role: z.string(),
    metadata: z.record(z.unknown()),
  })
  .passthrough();

export const aiMessageEventSchema = z
  .object({
    chat_id: z.string(),
    organization_id: z.string().optional(),
    agent_session_id: z.string().optional(),
    event: z.enum(["ai_message_end", "ai_message_reasoning"]),
    message_id: z.string().optional(),
    message: z.string().optional(),
    reasoning: z
      .array(
        z.object({
          follow_up_question_id: z.string(),
          follow_up_question_index: z.number(),
          reason_for_vendor: z.object({
            title: z.string(),
            description: z.string(),
          }),
        }),
      )
      .optional(),
  })
  .passthrough();

export const followUpAnsweredStatusEventSchema = z
  .object({
    chat_id: z.string(),
    organization_id: z.string(),
    agent_session_id: z.string(),
    event: z.string(),
    message_id: z.string(),
    answered_count: z.number(),
    answered_percent: z.number(),
    unanswered_count: z.number(),
    total_questions: z.number(),
    are_all_questions_answered: z.boolean(),
  })
  .passthrough();

// Validated types for use in SocketManager event handlers
export type FollowUpQuestionsGeneratedEventParsed = z.infer<
  typeof followUpQuestionsGeneratedEventSchema
>;
export type AiMessageEventParsed = z.infer<typeof aiMessageEventSchema>;
export type FollowUpAnsweredStatusEventParsed = z.infer<
  typeof followUpAnsweredStatusEventSchema
>;
